import React, { useState } from 'react';
import {
  required,
  SelectInput,
  SimpleForm,
  TextInput,
  NumberInput,
  ImageInput,
} from 'react-admin';
import { evidenceNumber, status, evidenceUnlockChoices } from '../../utils/choices';
import { validateFourStringCode, validateFourStringCodeOptional } from '../../utils/validation';
import { columnStyles } from 'styles';
import { PreviewImageField } from '../../Components';
import RichTextInput from 'ra-input-rich-text';
import { BaseForm } from '../../Components';
import { RichTextToolbar } from '../../utils/toolbarOptions';
import { validateDressCode } from '../../utils/validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Dialog, DialogTitle } from '@material-ui/core';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';


const validateCode = [required(), validateFourStringCode];
const validateCodeOptional = [validateFourStringCodeOptional];

const PlotForm = (props) => {
  const newProps = { ...props, customRedirect: '/plot' };

  const [fileInvalid, setFileInvalid] = React.useState(false);

  const [currentEvidenceNumber, setCurrentEvidenceNumber] = React.useState(
    props.record?.numberOfEvidence || 4
  );

  const handleEvidenceNumberChange = (event) => {
    const value = event.target.value;
    setCurrentEvidenceNumber(value);
  }


  const [showDialog, setShowDialog] = useState(false);

  const openModal = (record) => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  }

  const form = columnStyles('column', '30vw');
  return (
    <div>
      <Button style={{ marginTop: '15px', marginRight: '10px', paddingTop: '7px', width: '100%' }} onClick={() => { openModal() }}>
        <FontAwesomeIcon style={{ marginRight: '5px' }} icon={faInfoCircle} /> Evidence Unlock Info
      </Button>
      <Dialog open={showDialog} fullWidth
        onClose={handleCloseClick}
        aria-label={`Feedback detail`}
      >
        <DialogTitle id="alert-dialog-title">
          Evidence Unlock Information
        </DialogTitle>
        <div style={{ padding: '16px 24px', textAlign: 'center', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-around' }}>
          <div style={{ marginBottom: '10px', width: '30%' }}>
            <img src="https://murder57-evidence-unlocks.s3.eu-west-2.amazonaws.com/silver-lock.PNG" alt="evidence unlock info" style={{ width: '100%' }} />
            <br />
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Silver Lock
            </span>
          </div>
          <div style={{ marginBottom: '10px', width: '30%' }}>
            <img src="https://murder57-evidence-unlocks.s3.eu-west-2.amazonaws.com/golden-lock.PNG" alt="evidence unlock info" style={{ width: '100%' }} />
            <br />
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Golden Lock
            </span>
          </div>
          <div style={{ marginBottom: '10px', width: '30%' }}>
            <img src="https://murder57-evidence-unlocks.s3.eu-west-2.amazonaws.com/phone-lock.PNG" alt="evidence unlock info" style={{ width: '100%' }} />
            <br />
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Phone Lock
            </span>
          </div>
          <div style={{ marginBottom: '10px', width: '30%' }}>
            <img src="https://murder57-evidence-unlocks.s3.eu-west-2.amazonaws.com/safe-lock.PNG" alt="evidence unlock info" style={{ width: '100%' }} />
            <br />
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Safe Lock
            </span>
          </div>
          <div style={{ marginBottom: '10px', width: '30%' }}>
            <img src="https://murder57-evidence-unlocks.s3.eu-west-2.amazonaws.com/door-lock.PNG" alt="evidence unlock info" style={{ width: '100%' }} />
            <br />
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Door Lock
            </span>
          </div>
          <div style={{ marginBottom: '10px', width: '30%' }}>
            <img src="https://murder57-evidence-unlocks.s3.eu-west-2.amazonaws.com/suitcase-lock.PNG" alt="evidence unlock info" style={{ width: '100%' }} />
            <br />
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Suitcase Lock
            </span>
          </div>
          <div style={{ marginBottom: '10px', width: '30%' }}>
            <img src="https://murder57-evidence-unlocks.s3.eu-west-2.amazonaws.com/silhouette-target.PNG" alt="evidence unlock info" style={{ width: '100%' }} />
            <br />
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Silhouette Target
            </span>
          </div>
          <div style={{ marginBottom: '10px', width: '30%' }}>
            <img src="https://murder57-evidence-unlocks.s3.eu-west-2.amazonaws.com/chalk-outline.PNG" alt="evidence unlock info" style={{ width: '100%' }} />
            <br />
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Chalk Outline
            </span>
          </div>
          <div style={{ marginBottom: '10px', width: '30%' }}>
            <img src="https://murder57-evidence-unlocks.s3.eu-west-2.amazonaws.com/bookshelf.PNG" alt="evidence unlock info" style={{ width: '100%' }} />
            <br />
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Bookshelf
            </span>
          </div>
          <div style={{ marginBottom: '10px', width: '30%' }}>
            <img src="https://murder57-evidence-unlocks.s3.eu-west-2.amazonaws.com/typewriter.PNG" alt="evidence unlock info" style={{ width: '100%' }} />
            <br />
            <span style={{ fontWeight: 'bold', fontSize: '18px' }}>
              Typewriter
            </span>
          </div>

        </div>
      </Dialog>
      <BaseForm {...newProps}>
        <div className={form.container}>
          <TextInput
            className={form.column}
            source="name"
            label="Plot Name"
            validate={required()}
          />
          <SelectInput
            className={form.column}
            source="status"
            choices={status}
            validate={required()}
          />
          <TextInput
            className={form.column}
            source="suspectsCode"
            validate={validateCode}
          />
          <SelectInput
            className={form.column}
            source="numberOfEvidence"
            choices={evidenceNumber}
            validate={required()}
            onChange={handleEvidenceNumberChange}
            defaultValue={4}
          />
          <div className={form.column}>
            <TextInput
              className={form.halfColumnLeft}
              source="evidenceCode1"
              validate={validateCode}
            />
            <SelectInput
              className={form.halfColumnRight}
              source="evidenceUnlock1"
              choices={evidenceUnlockChoices}
              defaultValue="silver-lock"
            />
          </div>

          <div className={form.column}>
            <TextInput
              className={form.halfColumnLeft}
              source="evidenceCode2"
              validate={validateCode}
            />
            <SelectInput
              className={form.halfColumnRight}
              source="evidenceUnlock2"
              choices={evidenceUnlockChoices}
              defaultValue="silver-lock"
            />
          </div>

          {currentEvidenceNumber >= 3 && (
            <div className={form.column}>
              <TextInput
                className={form.halfColumnLeft}
                source="evidenceCode3"
                validate={validateCode}
              />
              <SelectInput
                className={form.halfColumnRight}
                source="evidenceUnlock3"
                choices={evidenceUnlockChoices}
                defaultValue="silver-lock"
              />
            </div>
          )}
          {currentEvidenceNumber >= 4 && (
            <div className={form.column}>
              <TextInput
                className={form.halfColumnLeft}
                source="evidenceCode4"
                validate={validateCode}
              />
              <SelectInput
                className={form.halfColumnRight}
                source="evidenceUnlock4"
                choices={evidenceUnlockChoices}
                defaultValue="silver-lock"
              />
            </div>
          )}
          {currentEvidenceNumber >= 5 && (
            <div className={form.column}>
              <TextInput
                className={form.halfColumnLeft}
                source="evidenceCode5"
                validate={validateCode}
              />
              <SelectInput
                className={form.halfColumnRight}
                source="evidenceUnlock5"
                choices={evidenceUnlockChoices}
                defaultValue="silver-lock"
              />
            </div>
          )}
          {currentEvidenceNumber >= 6 && (
            <div className={form.column}>
              <TextInput
                className={form.halfColumnLeft}
                source="evidenceCode6"
                validate={validateCode}
              />
              <SelectInput
                className={form.halfColumnRight}
                source="evidenceUnlock6"
                choices={evidenceUnlockChoices}
                defaultValue="silver-lock"
              />
            </div>
          )}
          {currentEvidenceNumber >= 7 && (
            <div className={form.column}>
              <TextInput
                className={form.halfColumnLeft}
                source="evidenceCode7"
                validate={validateCode}
              />
              <SelectInput
                className={form.halfColumnRight}
                source="evidenceUnlock7"
                choices={evidenceUnlockChoices}
                defaultValue="silver-lock"
              />
            </div>
          )}
          {currentEvidenceNumber >= 8 && (
            <div className={form.column}>
              <TextInput
                className={form.halfColumnLeft}
                source="evidenceCode8"
                validate={validateCode}
              />
              <SelectInput
                className={form.halfColumnRight}
                source="evidenceUnlock8"
                choices={evidenceUnlockChoices}
                defaultValue="silver-lock"
              />
            </div>
          )}
          {currentEvidenceNumber >= 9 && (
            <div className={form.column}>
              <TextInput
                className={form.halfColumnLeft}
                source="evidenceCode9"
                validate={validateCode}
              />
              <SelectInput
                className={form.halfColumnRight}
                source="evidenceUnlock9"
                choices={evidenceUnlockChoices}
                defaultValue="silver-lock"
              />
            </div>
          )}
          {currentEvidenceNumber >= 10 && (
            <div className={form.column}>
              <TextInput
                className={form.halfColumnLeft}
                source="evidenceCode10"
                validate={validateCode}
              />
              <SelectInput
                className={form.halfColumnRight}
                source="evidenceUnlock10"
                choices={evidenceUnlockChoices}
                defaultValue="silver-lock"
              />
            </div>
          )}
          <TextInput
            className={form.column}
            source="discountCode"
            validate={required()}
          />
          <TextInput
            className={form.column}
            source="dressCode"
            validate={validateDressCode}
          />
          <NumberInput
            className={form.column}
            source="maxActors"
            validate={required()}
            min={0}
          />
          <RichTextInput
            className={form.column}
            label="Plot Description"
            source="description"
            validate={required()}
            multiline
            toolbar={RichTextToolbar}
          />
          <div className={form.column}>
            <ImageInput
              label="Plot Image"
              source="image"
              maxSize={1500000}
              validate={required()}
              onChange={(e) => {
                if (e) {
                  setFileInvalid(false);
                } else {
                  setFileInvalid(true);
                }
              }}
              options={{
                onRemove: (e) => {
                  setFileInvalid(false);
                },
              }}
              placeholder={
                <h5>
                  Drop a picture to upload, or click to select it.<br></br>Max size
                  1.5MB
                </h5>
              }
            >
              <PreviewImageField />
            </ImageInput>
            <div style={{ display: fileInvalid ? 'block' : 'none', color: '#f44336', fontSize: '0.75rem' }}>
              Image file size too large or invalid file type.
            </div>
          </div>
        </div>
      </BaseForm>
    </div>
  );
};

export default PlotForm;
